import {  ChangeDetectorRef, Component,  OnInit,  ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from './dashboard.service';
import { ICategories, IDashbordCategoryFilterReponse, keyMap,  TotalCategories } from './dashboard.model';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { DecimalPipe } from '@angular/common';
import { CommonService } from '../../helpers/common.service';
import {
  MatDialog,
} from '@angular/material/dialog';
import { GraphDialogComponent } from './graph-dialog/graph-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { companies } from '../../models/company.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DecimalPipe]  // Provide DecimalPipe here
})

export class DashboardComponent implements OnInit {

  dashboardForm: FormGroup;
  categories: ICategories[]  // Replace with actual categories
  isAllSelected: boolean = false;
  minDate: Date;
  maxDate: Date;
  startDate: any;
  endDate: any;
  name: any;
  category: any;
  companyId: number;
  selectedValue: IDashbordCategoryFilterReponse;
  totalCategories : any = [];
  mappedCategories: {
    [x: string]: any;
    name: string; // Name from TotalCategories
    value: string | number; // Value from dataObject using keyMap, can be string (e.g., for star ratings) or number
  }[];
  categoryIds: number[];
  whichGraph : boolean = true;
  showServiceType: boolean = true;
  showCharts: boolean = true;
  isLoading: boolean = true;

  @ViewChild('dashboardpicker') dashboardpicker!: MatDateRangePicker<Date>;
  private apiCalled: boolean = false;
  stores: [] =  [];
  totalNoOfStores:number = 0;
  
  openDatePicker(): void {
    this.dashboardpicker.open();  // Opens the date picker when the image is clicked
  }
  
  constructor(private dashboardService: DashboardService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private decimalPipe: DecimalPipe,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) { 
    const currentYear = new Date().getFullYear(); 
    const currentMonth = new Date().getMonth();
    const currentDate  = new Date().getDate();
    this.minDate = new Date(2022, 9, 93); // Default October 1st, 2022
    this.maxDate = new Date(currentYear , currentMonth, currentDate);
  }

  ngOnInit(): void {
    const companyIdval = localStorage.getItem('companyId');
    this.companyId = companyIdval ? Number.parseInt(companyIdval, 10) : 0;
    const company = companies.find(c => c.id === this.companyId);
    this.minDate = company?.minDate || this.minDate; // Use company-specific minDate if available
    this.showServiceType = company?.showServiceType ?? true; // Use company-specific showServiceType if available
    this.showCharts = company?.showCharts ?? true; // Use company-specific showCharts if available
    this.totalCategories = TotalCategories //this.companyId != 4 ? TotalCategories : parxisTotalCategories 
    // Initialize the form controls
    this.initializeDates();
    this.initializeForm();
   
    this.commonService.getCategories(this.companyId).subscribe((categories) => {
      this.categories = categories;
      if (categories && Object.keys(categories).length) {
        // If categories is an object, convert it to an array
          this.categories = categories
        // Set categories in the form and select all by default
        const defaultCategory = this.categories.map(cat => cat.id);
        const allCategory = this.categories.find(cat => cat.id === 0);
        this.dashboardForm.controls['category'].setValue([...defaultCategory]);
        this.isAllSelected = true;
        this.isLoading = false;
         this.makeApiCallWithCategoryIds(defaultCategory);
        }
    });

     this.commonService.getStores(this.companyId).subscribe((stores) => {
      this.stores = stores;
      this.totalNoOfStores = stores.length;
    });
  }


  // Initialize the date controls
  initializeDates() {
    this.startDate = new Date(new Date().getFullYear(), 0, 1); // Start: Jan 1st of current year
    this.endDate = new Date();  // End: today
  }

  // Initialize the form controls
  initializeForm() {
    this.dashboardForm = this.fb.group({
      category: [[], Validators.required],  // Multi-select for categories
      startDate: [this.startDate, Validators.required],
      endDate: [this.endDate, Validators.required],
      companyId: [this.companyId, Validators.required]
    });
  }
 
  //on Date Change
  onDateRangeChange(): void {
    const sDate = this.dashboardForm.controls['startDate'].value;
    const eDate = this.dashboardForm.controls['endDate'].value;
    if ((eDate !== null && sDate !== null) || eDate > sDate && this.companyId !== null && this.categoryIds !== null) {
      if (sDate.getTime() === this.startDate.getTime() && eDate.getTime() === this.endDate.getTime()) {
        this.makeApiCallWithCategoryIds(this.categoryIds);
      } else {
        this.startDate = sDate;
        this.endDate = eDate;
        this.apiCalled = false; // Reset apiCalled flag to allow new API call
        this.makeApiCallWithCategoryIds(this.categoryIds);
      }
    }
  }

  onCategorySelectionChange(event: any): void {
    let selectedCategory: number[] = event.value;
    const allCategoryIds = this.categories.map(cat => cat.id);
    switch (true) {
      // Case 1: "All" is selected
      case selectedCategory.includes(0):
        this.isAllSelected = true;
        // Set the form control to include all categories, Selecting all categories including "All"
        if (selectedCategory.length === allCategoryIds.length - 1) {
          selectedCategory = selectedCategory.filter(n => n !== 0);
          selectedCategory = selectedCategory;
        } else {
          selectedCategory = [...allCategoryIds];
        }
        break;

      // Case 2: No categories selected
      case selectedCategory.length === (this.categories.length - 1) && !selectedCategory.includes(0) && this.isAllSelected === false:
        this.isAllSelected = true;
        // Set only the second option as selected
        selectedCategory = [...allCategoryIds];
        break;

      // Case 3: All categories except "All" are selected
      case selectedCategory.length === (this.categories.length - 1) && !selectedCategory.includes(0) && this.isAllSelected === true:
        this.isAllSelected = false;
        // Set only the second option as selected
        selectedCategory = [];
        break;

      // Default: Other cases (some categories selected)
      default:
        this.isAllSelected = false;
        // Do nothing, as `selectedCategoryIds` is already set correctly
        break;
    }

    // Set the selected categories in the form control
    this.dashboardForm.controls['category'].setValue(selectedCategory);
    // Make a single call to the API with the selected categories, stores, and status
    this.makeApiCallWithCategoryIds(selectedCategory);
  }


  // Make an API call with selected category IDs
  makeApiCallWithCategoryIds(selectedCategoryIds: number[]): void {
    this.categoryIds = selectedCategoryIds
    const params = {
      categoryIds: selectedCategoryIds,
      startDate: this.startDate,
      endDate: this.endDate,
      companyId: this.companyId
    };
    if(selectedCategoryIds.length === 0){
      this.mappedCategories = [];
      return;
    }
    if (this.apiCalled) {
      return;
    }
    this.apiCalled = true;
    this.dashboardService.getAllCategoryCounts(params).subscribe(
      (res: any) => {
        // Mapping TotalCategories into an array of objects with 'name' and 'value'
        this.mappedCategories = this.totalCategories.map((category:any) => ({
          name: category,  // Name from TotalCategories
          value: res[keyMap[category as keyof typeof keyMap]]  // Value from dataObject using keyMap
        }));

        this.mappedCategories = this.mappedCategories.map(booking => {
          if (booking.name === 'Lead time') {
            const leadTime = booking['value'].toString();
            if(Number.parseInt(leadTime) <= 1){
              booking['value'] = this.decimalPipe.transform(leadTime, '1.1-2') + ` day`;
            } else {
              booking['value'] = this.decimalPipe.transform(leadTime, '1.1-2') + ` days`;
            }
          }
          let starRating = '';

          if (booking['name'] === 'Avg. Rating') {
            if (booking['value'] === 0) {
              booking['value'] = 'No rating yet'; // Display message if no rating
            } else {
              // Generate filled stars based on rating value
              const fullStars = Math.floor(Number.parseInt(String(booking['value']))); // Get the number of full stars
              const modValue = parseFloat(String(booking['value'])) % 1; // Get the decimal part of the value
              const hasHalfStar = modValue < 0.5; // Check if there should be a half star

              const emptyStars = 5 - fullStars - 1; // Calculate remaining empty stars

              // Add full stars
              for (let i = 0; i < fullStars; i++) {
                starRating += '★';
              }

              // Add half star or another full star based on modValue
              if (hasHalfStar && modValue < 0.5) {
                starRating += '<i class="fa fa-star-half-alt half-star-size"></i>'; // Half star icon
              } else if (!hasHalfStar && modValue >= 0.5) {
                starRating += '★'; // Full star icon
              }

              // Add empty stars to fill up the 5-star rating
              for (let i = 0; i < emptyStars; i++) {
                starRating += '☆'; // Empty star icon
              }

              // Modified: Append the empty stars
              if(emptyStars != -1) starRating += '☆'.repeat(emptyStars); // Empty stars
              booking['value'] = starRating + ' <span class="star-rating-value-msg">(' + this.decimalPipe.transform(booking.value, '1.1-2') + ')</span>';
            }
          }

          return {
            ...booking
          };
        });

        // Trigger change detection after data has been updated
        this.cd.detectChanges();
        this.apiCalled = false;
      },
      (error) => {
         this._snackBar.open('Some thing went wrong while load Dashboard counts. Please re-login', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
        return;
        console.error('Error fetching category counts:', error);
      }
    );
  }

  // Compare categories based on their ID
  compareCategories(category1: any, category2: any): boolean {
    return category1 && category2 ? category1 === category2 : category1 === category2;
  }

  isOptionDisabled(category: any): boolean {
    // Disable all options if "All" is selected
    if (this.isAllSelected && category.id !== 0) {
      return true;
    }

    // Disable "All" if any other option is selected
    if (!this.isAllSelected && category.id === 0) {
      this.dashboardForm.controls['category'].setValue([this.categories[1]])
      return true;
    }

    return false;
  }

  zoomGraph(flag:number){
    this.dialog.open(GraphDialogComponent, {
      height: "calc(100% - 30px)",
      width: "calc(100% - 30px)",
      maxWidth: "100%",
      maxHeight: "100%",
      data: {
        startDate: this.dashboardForm.controls['startDate'].value,
        endDate: this.dashboardForm.controls['endDate'].value,
        categoryIds: this.categoryIds,
        companyId:this.companyId,
        whichGraph: flag
      }
    });
  }
}